import { instanceWithV2 as instance } from './SimpleAPIClient';
import CONFIG from '../config/config';

export interface LiveHomepageAd {
  id: number;
  name: string;
  imageUrl: string;
  title: string;
  ctaText: string;
  modalTitle: string;
  modalBody: string;
}

export interface HomepageAdInterestResponse {
  whatsappUrl: string;
  mailtoUrl: string;
  instagramUrl: string;
  alreadyInterested: boolean;
}

const HomepageAdsAPI = {
  listLive: async (locale: string): Promise<LiveHomepageAd[]> => {
    const response = await instance(CONFIG.API_ENDPOINT).get<LiveHomepageAd[]>(
      `/v1/homepage-ads?locale=${encodeURIComponent(locale)}`
    );
    return response.data;
  },

  registerInterest: async (id: number): Promise<HomepageAdInterestResponse> => {
    const response = await instance(CONFIG.API_ENDPOINT).post<HomepageAdInterestResponse>(
      `/v1/homepage-ads/${id}/interest`,
      {}
    );
    return response.data;
  },

  recordView: async (id: number): Promise<void> => {
    await instance(CONFIG.API_ENDPOINT).post(`/v1/homepage-ads/${id}/view`, {});
  },

  recordEngagement: async (id: number): Promise<void> => {
    await instance(CONFIG.API_ENDPOINT).post(`/v1/homepage-ads/${id}/engagement`, {});
  },
};

export default HomepageAdsAPI;
